import { useCallback } from 'react';
/**
 * A hook that adds a fallback for `defaultMessage` (in form of descriptor id wrapped in double parenthesis)
 * to the `formatMessage` and returns updated version of function. It is done for convenience,
 * so that we don't have to provide `defaultMessage` each time `formatMessage` is used.
 * @param intl - The intl object that contains the `formatMessage` function.
 * @returns A function that formats a message descriptor into a string.
 */
export const useExtendedFormatMessage = (intl) => {
    return useCallback((descriptor, values) => {
        return intl.formatMessage({
            ...descriptor,
            defaultMessage: descriptor.defaultMessage ?? `[[${descriptor.id ?? ''}]]`,
        }, values);
    }, [intl]);
};
//# sourceMappingURL=useExtendedFormatMessage.js.map